module.exports = __webpack_public_path__ + "static/media/Townhouse.92ea348e.svg";